const category = 'AppSpecificWorkManagement';

const cards = [
    {
        name: "Liability Processing",
        id: "DeferLiabilityProcessinginRecovery",
        fields: [
            [{id: 'DeferLiabilityProcessinginRecovery'}]
        ],
    },
    {
        name: "Assignment Routing",
        id: "TieredServicesAssignmentRouting",
        fields: [
            [{id: 'TieredServicesIsClientAssignmentsEnabled'}],
            [{id: 'ClientAssignmentGroupContent'}],
            [{id: 'IsClientAssignmentAccounting'}],
            [{id: 'IsClientAssignmentApprovals'}],
            [{id: 'IsClientAssignmentNotifications'}],
            [{id: 'IsClientAssignmentProcessLiability'}],
            [{id: 'IsClientAssignmentPCReview'}],
            [{id: 'IsClientAssignmentInboundCorrespondence'}],
            [{id: 'TieredServicesIsTransferAssignmentsEnabled'}],
            [{id: 'TransferClientAssignmentContent'}],
            [{id: 'IsTransferableClientAssignmentInboundCorrespondence'}],
        ]
    }
];

export { cards, category };